import React from "react";
import styled from "styled-components";
import { useLang } from "../i18n/LanguageContext";

const ToggleButton = styled.button`
  position: fixed;
  top: 14px;
  right: 14px;
  z-index: 9999;
  min-width: 48px;
  padding: 8px 14px;
  border: 1.5px solid #764ba2;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.92);
  color: #764ba2;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  transition: background 0.2s, transform 0.15s;

  &:hover {
    background: #764ba2;
    color: #fff;
    transform: translateY(-1px);
  }
`;

/**
 * 전역 한/영 토글. App 최상단에 한 번만 렌더되어 모든 페이지에 떠 있다.
 * 버튼 라벨은 "전환될 언어"를 보여준다 (한국어 화면 → "EN", 영어 화면 → "한").
 */
export default function LangToggle() {
  const { lang, setLang, t } = useLang();
  return (
    <ToggleButton
      type="button"
      aria-label="Switch language"
      onClick={() => setLang(lang === "ko" ? "en" : "ko")}
    >
      {t("common.langToggle")}
    </ToggleButton>
  );
}
